module.exports = __webpack_public_path__ + "static/img/504_phase_function_Paper_Points.3f86c8c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/504_phase_function_Paper_Points.png
// module id = QY6u
// module chunks = 0